export const SET_DISPLAY_MILITARY = "USERPREFS_SET_DISPLAY_MILITARY";
export const SET_TIME_ZONE = "USERPREFS_SET_TIME_ZONE";

export interface UserPrefsState {
  displayMilitary: boolean;
  timeZone: string;
}
